import e from "./RefinementList.vue_rollup-plugin-vue=script.js";
export default (function (e, t, s, a, r, n, i, o) {
  var c = ("function" == typeof s ? s.options : s) || {};
  return c.__file = "RefinementList.vue", c.render || (c.render = e.render, c.staticRenderFns = e.staticRenderFns, c._compiled = !0, r && (c.functional = !0)), c._scopeId = a, c;
})({
  render: function render() {
    var e = this,
        t = e.$createElement,
        s = e._self._c || t;
    return e.state ? s("div", {
      class: [e.suit(), 0 === e.items.length && e.suit("", "noRefinement")]
    }, [e._t("default", function () {
      var t;
      return [e.searchable ? s("div", {
        class: e.suit("searchBox")
      }, [s("search-input", {
        attrs: {
          "show-loading-indicator": !0,
          placeholder: e.searchablePlaceholder,
          "class-names": e.classNames
        },
        model: {
          value: e.searchForFacetValues,
          callback: function callback(t) {
            e.searchForFacetValues = t;
          },
          expression: "searchForFacetValues"
        }
      })], 1) : e._e(), e._v(" "), e.state.isFromSearch && 0 === e.items.length ? e._t("noResults", function () {
        return [s("div", {
          class: e.suit("noResults")
        }, [e._v("No results.")])];
      }, {
        query: e.searchForFacetValues
      }) : e._e(), e._v(" "), e.items.length > 0 ? s("ul", {
        class: e.suit("list")
      }, e._l(e.items, function (t) {
        return s("li", {
          key: t.value,
          class: [e.suit("item"), t.isRefined && e.suit("item", "selected")]
        }, [e._t("item", function () {
          return [s("label", {
            class: e.suit("label")
          }, [s("input", {
            class: e.suit("checkbox"),
            attrs: {
              type: "checkbox"
            },
            domProps: {
              value: t.value,
              checked: t.isRefined
            },
            on: {
              change: function change(s) {
                return e.refine(t.value);
              }
            }
          }), e._v(" "), e.searchable ? s("span", {
            class: e.suit("labelText")
          }, [s("ais-highlight", {
            attrs: {
              attribute: "item",
              hit: t
            }
          })], 1) : s("span", {
            class: e.suit("labelText")
          }, [e._v(e._s(t.label))]), e._v(" "), s("span", {
            class: e.suit("count")
          }, [e._v(e._s(t.count))])])];
        }, {
          item: t,
          refine: e.refine,
          createURL: e.state.createURL
        })], 2);
      }), 0) : e._e(), e._v(" "), e.showMore ? s("button", {
        class: [e.suit("showMore"), (t = {}, t[e.suit("showMore", "disabled")] = !e.state.canToggleShowMore, t)],
        attrs: {
          disabled: !e.state.canToggleShowMore
        },
        on: {
          click: e.toggleShowMore
        }
      }, [e._t("showMoreLabel", function () {
        return [e._v("\n        Show " + e._s(e.state.isShowingMore ? "less" : "more") + "\n      ")];
      }, {
        isShowingMore: e.state.isShowingMore
      })], 2) : e._e()];
    }, {
      items: e.items,
      refine: e.refine,
      searchForItems: e.state.searchForItems,
      searchForItemsQuery: e.searchForFacetValuesQuery,
      toggleShowMore: e.toggleShowMore,
      canToggleShowMore: e.state.canToggleShowMore,
      isShowingMore: e.state.isShowingMore,
      createURL: e.state.createURL,
      isFromSearch: e.state.isFromSearch,
      canRefine: e.state.canRefine,
      sendEvent: e.state.sendEvent
    })], 2) : e._e();
  },
  staticRenderFns: []
}, 0, e, void 0, !1);